import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';

function NotFound() {
  return (
    <Container>
      <div className="myrow" style={{ height: "100vh", textAlign: "center", paddingTop: "10%" }}>
        <h1>404</h1>
        <p>Sorry, we couldn't find the page you're looking for.</p>
        <Link to="/">Go back home</Link>
      </div>
    </Container>
  );
}

export default NotFound;
